import ContasTab from "./view/contas.tab"
export const ContasListView = ContasTab